import { render } from "./EditorNavbar.vue?vue&type=template&id=e27b20d8"
import script from "./EditorNavbar.vue?vue&type=script&lang=js"
export * from "./EditorNavbar.vue?vue&type=script&lang=js"

import "./EditorNavbar.vue?vue&type=style&index=0&id=e27b20d8&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__